(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    function openNewsletterAccordion() {
    const details = Array.from(document.querySelectorAll('details')).find((el) => {
      const summary = el.querySelector('summary');
      return summary && summary.textContent.toLowerCase().includes('iscriviti alla newsletter');
    });

    if (!details) return;

    details.open = true;

    setTimeout(() => {
      details.scrollIntoView({ behavior: 'smooth', block: 'center' });

      const emailInput = details.querySelector('input[type="email"]');
      if (emailInput) {
        setTimeout(() => emailInput.focus(), 300);
      }
    }, 150);
  }

  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.promo-newsletter-trigger');
    if (!trigger) return;

    e.preventDefault();
    openNewsletterAccordion();
  });

  document.addEventListener('keydown', function(e) {
    const trigger = e.target.closest('.promo-newsletter-trigger');
    if (!trigger) return;

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      openNewsletterAccordion();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
